module.exports = __webpack_public_path__ + "static/media/N3.4a13a26a.png";